import '../style/message-GdrFM1D3.css'
import { defineComponent as C, ref as I, openBlock as t, createElementBlock as o, createElementVNode as _, createVNode as L, TransitionGroup as b, withCtx as B, Fragment as y, renderList as H, normalizeClass as D, createBlock as k, unref as E, createCommentVNode as s, toDisplayString as v, normalizeStyle as $, h as N, render as z } from "vue";
import V from "./icon.js";
import F from "./internalComponents/CrossIcon.js";
const S = { class: "e-message" }, q = ["innerHTML"], G = ["innerHTML"], O = {
  key: 0,
  class: "e-message-title"
}, P = {
  key: 1,
  class: "e-message-description"
}, Y = /* @__PURE__ */ C({
  name: "e-message",
  __name: "message",
  props: {
    title: {},
    type: {},
    description: {},
    allowHTML: { type: Boolean },
    duration: { default: 3e3 },
    closable: { type: Boolean, default: !0 },
    allowDuplication: { type: Boolean }
  },
  setup(d, { expose: p }) {
    const m = d, M = {
      success: "check-circle-fill",
      info: "info-circle-fill",
      warning: "info-circle-fill",
      error: "cross-circle-fill"
    }, l = I([]);
    function h(n) {
      return l.value.some(
        (i) => w(i, n)
      );
    }
    function w(n, i) {
      const { type: e, title: c, description: r } = n, { type: a, title: f, description: x } = i;
      return e === a && c === f && r === x;
    }
    function T(n) {
      const i = Date.now(), e = n.duration || m.duration, c = n.closable ?? m.closable, r = {
        type: "success",
        duration: e,
        closable: c,
        ...n
      };
      !m.allowDuplication && h(r) || (l.value.push({
        key: i,
        ...r
      }), setTimeout(() => {
        const a = l.value.findIndex((f) => f.key === i);
        a >= 0 && l.value.splice(a, 1);
      }, e));
    }
    function g(n) {
      const i = l.value.findIndex((e) => e.key === n.key);
      l.value.splice(i, 1);
    }
    return p({
      addItem: T
    }), (n, i) => (t(), o("div", S, [
      _("ul", null, [
        L(b, { name: "e-message__list" }, {
          default: B(() => [
            (t(!0), o(y, null, H(l.value, (e) => (t(), o("li", {
              key: e.key,
              class: D([
                "e-message-item",
                `e-message-item--${e.type}`,
                {
                  "e-message-item--no-title": !e.title
                }
              ])
            }, [
              e.type ? (t(), k(E(V), {
                key: 0,
                size: 20,
                icon: M[e.type],
                class: "e-message-icon"
              }, null, 8, ["icon"])) : s("", !0),
              e.allowHTML ? (t(), o(y, { key: 1 }, [
                e.title ? (t(), o("div", {
                  key: 0,
                  class: "e-message-title",
                  innerHTML: e.title
                }, null, 8, q)) : s("", !0),
                e.description ? (t(), o("div", {
                  key: 1,
                  class: "e-message-description",
                  innerHTML: e.description
                }, null, 8, G)) : s("", !0)
              ], 64)) : (t(), o(y, { key: 2 }, [
                e.title ? (t(), o("div", O, v(e.title), 1)) : s("", !0),
                e.description ? (t(), o("div", P, v(e.description), 1)) : s("", !0)
              ], 64)),
              e.closable ? (t(), k(F, {
                key: 3,
                class: "e-message-close",
                onClick: (c) => g(e)
              }, null, 8, ["onClick"])) : s("", !0),
              _("div", {
                class: "e-message-progress",
                style: $({ "animation-duration": `${e.duration}ms` })
              }, null, 4)
            ], 2))), 128))
          ]),
          _: 1
        })
      ])
    ]));
  }
});
let u;
const K = (d) => {
  if (!u) {
    const p = document.body.appendChild(document.createElement("div"));
    u = N(Y), z(u, p);
  }
  u.component.exposed.addItem(d);
};
export {
  K as MessageFn,
  Y as default
};
//# sourceMappingURL=message.js.map
